import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import Icon from 'components/atoms/Icon';
import { bindActionCreators, Dispatch } from 'redux';
import { portSetDefaultValue } from 'services/ports';
import { SetErrorHandlerAction, setErrorHandlerAction } from 'store/actions/errorsActions';
import { PortType, RootState } from 'types';
import { ActionsType } from 'types/system';
import { formatServerErrors } from 'utils/formatServerErrors';
import { translate } from 'utils/translate';

interface InitDefaultValueModalModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;

    id?: string;
    data: any;
    actions: ActionsType | undefined;

    //unused props
    port: PortType;

    setErrorHandlerAction: SetErrorHandlerAction;
}

interface InitDefaultValueModalModelState {
    errors: object;

    //unused state
    data: any | null;

    loading: boolean;

    //unused state
    overwite: boolean;
}

class InitDefaultValueModalModel extends Component<InitDefaultValueModalModelProps, InitDefaultValueModalModelState> {
    constructor(props: InitDefaultValueModalModelProps) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            loading: false,
            overwite: false,
        };
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.setState({ errors: {}, loading: true }, () => {
            portSetDefaultValue(this.props.data.port.id)
                .then(() => {
                    this.props.actions?.onConfirm();
                    this.props.actions?.onCancel();
                })
                .catch((errors) => {
                    switch (errors.response?.status) {
                        case 422:
                            this.setState({ errors: formatServerErrors(errors), loading: false });
                            break;
                        default:
                            this.setState({ loading: false });
                            this.props.setErrorHandlerAction(errors);
                            break;
                    }

                    return;
                });
        });
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('Initial default value')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>

                    <div className="mt-5 flex items-center gap-1 text-md text-gray-400">
                        {translate('Are you sure to reset default values data this port ?')}
                    </div>

                    <div className="flex justify-end">
                        <div className="mt-5 flex gap-3">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                            <Button
                                disabled={this.state.loading}
                                loading={this.state.loading}
                                type="submit"
                                className="px-4 py-2 bg-primary-submit rounded-md text-white"
                            >
                                {translate('Initial')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const InitDefaultValueModalModelStateToProps = (state: RootState) => ({
    language: state.user.user.language,
    port: state.port.port,
});

const InitDefaultValueModalModelDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
});

export default connect(
    InitDefaultValueModalModelStateToProps,
    InitDefaultValueModalModelDispatchToProps
)(InitDefaultValueModalModel);
